import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import App from './App';
// eslint-disable-next-line import/no-named-as-default
import configureStore from './redux/configureStore';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

// Create redux store
const initialState = {};
export const store = configureStore(initialState);

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root')
);

if (module.hot) {
    module.hot.accept();
}